// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-window-add-strap {
  display: none;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-window-straps-content {
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 160px;
  height: 60%;
  background: #fff;
  z-index: 99;
  max-width: 720px;
}
@media (max-width: 960px) {
  .modal-window-straps-content {
    height: 100%;
    margin-top: 60px;
  }
}
.modal-window-straps-content .image-item {
  display: flex;
}
.modal-window-straps-content .image-item .image-class-wrapper {
  display: flex;
  flex-shrink: 0;
}
.modal-window-straps-content .headline-wrapper {
  padding: 15px 30px 10px;
  position: relative;
  border: 1px solid #ebebeb;
}
@media (max-width: 960px) {
  .modal-window-straps-content .headline-wrapper {
    padding-top: 40px;
  }
}
.modal-window-straps-content .headline-wrapper .headline {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 24px;
  display: flex;
  justify-content: center;
}
.modal-window-straps-content .headline-wrapper .close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
}
.modal-window-straps-content .product-content-wrapper {
  overflow-y: auto;
  display: flex;
  padding: 15px;
  height: 100%;
}
@media (max-width: 960px) {
  .modal-window-straps-content .product-content-wrapper {
    flex-direction: column;
  }
}
.modal-window-straps-content .product-content-wrapper .watch-product-info {
  width: 35%;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  margin: auto;
}
@media (max-width: 960px) {
  .modal-window-straps-content .product-content-wrapper .watch-product-info {
    width: 100%;
    margin: 0 auto 30px auto;
  }
}
.modal-window-straps-content .product-content-wrapper .watch-product-info .product-display-image {
  justify-content: center;
}
.modal-window-straps-content .product-content-wrapper .watch-product-info .product-info {
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1;
  padding-top: 15px;
  text-align: center;
}
.modal-window-straps-content .strap-products-blocks {
  width: 65%;
  overflow-y: auto;
}
@media (max-width: 960px) {
  .modal-window-straps-content .strap-products-blocks {
    width: 85%;
    margin: 0 auto;
  }
}
.modal-window-straps-content .add-to-cart-stap-wrapper {
  padding: 15px 30px;
  border-top: 1px solid #ebebeb;
}
.modal-window-straps-content .add-to-cart-stap-wrapper .additional-content {
  font-size: 14px;
  padding-bottom: 10px;
  text-align: center;
}
.modal-window-straps-content .add-to-cart-stap-wrapper .add-to-cart-wrapper {
  display: flex;
}
.modal-window-straps-content .add-to-cart-stap-wrapper .add-to-cart-wrapper button {
  margin: auto;
}

.product-item-wrapper {
  cursor: pointer;
  border: 1px solid #ebebeb;
  padding: 5px;
  margin-bottom: 15px;
  display: flex;
}
.product-item-wrapper:hover {
  background: #0e2240;
  color: #fff;
}
.product-item-wrapper:hover .buckle-info {
  color: #fff;
}
.product-item-wrapper .image-item-strap {
  margin-right: 5px;
}
.product-item-wrapper .content-wrapper {
  padding: 0 15px;
  max-width: 340px;
}
.product-item-wrapper .content-wrapper .product-header {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
}
.product-item-wrapper .content-wrapper .buckle-info {
  font-size: 10px;
  color: #77777a;
  letter-spacing: 0;
}
.product-item-wrapper .content-wrapper .price {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  box-sizing: border-box;
}

.active-strap {
  background: #0e2240;
  color: #fff;
}
.active-strap .buckle-info {
  color: #fff;
}

.strap-header {
  margin: auto 10px auto 0;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/product.bundle/modal-window/modal-window.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AACF;AACE;EAVF;IAWI,YAAA;IACA,gBAAA;EAEF;AACF;AAAE;EACE,aAAA;AAEJ;AAAI;EACE,aAAA;EACA,cAAA;AAEN;AAEE;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AAEI;EALF;IAMI,iBAAA;EACJ;AACF;AACI;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AACN;AAEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;AAAN;AAIE;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;AAFJ;AAII;EANF;IAOI,sBAAA;EADJ;AACF;AAGI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AADN;AAGM;EAPF;IAQI,WAAA;IACA,wBAAA;EAAN;AACF;AAEM;EACE,uBAAA;AAAR;AAGM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AADR;AAME;EACE,UAAA;EACA,gBAAA;AAJJ;AAMI;EAJF;IAKI,UAAA;IACA,cAAA;EAHJ;AACF;AAME;EACE,kBAAA;EACA,6BAAA;AAJJ;AAMI;EACE,eAAA;EACA,oBAAA;EACA,kBAAA;AAJN;AAOI;EACE,aAAA;AALN;AAOM;EACE,YAAA;AALR;;AAWA;EACE,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AARF;AAUE;EACE,mBAAA;EACA,WAAA;AARJ;AAUI;EACE,WAAA;AARN;AAYE;EACE,iBAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAXN;AAcI;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAZN;AAeI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,WAAA;AAfF;AAiBE;EACE,WAAA;AAfJ;;AAmBA;EACE,wBAAA;AAhBF","sourcesContent":[".modal-window-add-strap {\n  display: none;\n  position: fixed;\n  z-index: 99;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-window-straps-content {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  margin-top: 160px;\n  height: 60%;\n  background: #fff;\n  z-index: 99;\n  max-width: 720px;\n\n  @media (max-width: 960px) {\n    height: 100%;\n    margin-top: 60px;\n  }\n\n  .image-item {\n    display: flex;\n\n    .image-class-wrapper {\n      display: flex;\n      flex-shrink: 0;\n    }\n  }\n\n  .headline-wrapper {\n    padding: 15px 30px 10px;\n    position: relative;\n    border: 1px solid #ebebeb;\n\n    @media (max-width: 960px) {\n      padding-top: 40px;\n    }\n\n    .headline {\n      text-transform: uppercase;\n      font-weight: 600;\n      font-size: 24px;\n      display: flex;\n      justify-content: center;\n    }\n\n    .close-button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 15px;\n    }\n  }\n\n  .product-content-wrapper {\n    overflow-y: auto;\n    display: flex;\n    padding: 15px;\n    height: 100%;\n\n    @media (max-width: 960px) {\n      flex-direction: column;\n    }\n\n    .watch-product-info {\n      width: 35%;\n      display: flex;\n      flex-direction: column;\n      padding-right: 10px;\n      margin: auto;\n\n      @media (max-width: 960px) {\n        width: 100%;\n        margin: 0 auto 30px auto;\n      }\n\n      .product-display-image {\n        justify-content: center;\n      }\n\n      .product-info {\n        text-transform: uppercase;\n        font-size: 20px;\n        font-weight: 600;\n        letter-spacing: 0;\n        line-height: 1;\n        padding-top: 15px;\n        text-align: center;\n      }\n    }\n  }\n\n  .strap-products-blocks {\n    width: 65%;\n    overflow-y: auto;\n\n    @media (max-width: 960px) {\n      width: 85%;\n      margin: 0 auto;\n    }\n  }\n\n  .add-to-cart-stap-wrapper {\n    padding: 15px 30px;\n    border-top: 1px solid #ebebeb;\n\n    .additional-content {\n      font-size: 14px;\n      padding-bottom: 10px;\n      text-align: center;\n    }\n\n    .add-to-cart-wrapper {\n      display: flex;\n\n      button {\n        margin: auto;\n      }\n    }\n  }\n}\n\n.product-item-wrapper {\n  cursor: pointer;\n  border: 1px solid #ebebeb;\n  padding: 5px;\n  margin-bottom: 15px;\n  display: flex;\n\n  &:hover {\n    background: #0e2240;\n    color: #fff;\n\n    .buckle-info {\n      color: #fff;\n    }\n  }\n\n  .image-item-strap {\n    margin-right: 5px;\n  }\n\n  .content-wrapper {\n    padding: 0 15px;\n    max-width: 340px;\n\n    .product-header {\n      font-size: 16px;\n      font-weight: 400;\n      text-transform: uppercase;\n    }\n\n    .buckle-info {\n      font-size: 10px;\n      color: #77777a;\n      letter-spacing: 0;\n    }\n\n    .price {\n      font-size: 14px;\n      font-weight: 400;\n      letter-spacing: 0;\n      box-sizing: border-box;\n    }\n  }\n}\n\n.active-strap {\n  background: #0e2240;\n  color: #fff;\n\n  .buckle-info {\n    color: #fff;\n  }\n}\n\n.strap-header {\n  margin: auto 10px auto 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
